import SFetch from '@app/utils/sfetch'

export default {
  toggleFollow(id) {
    const url = Silverfin.Routes.toggle_follow_commentable_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      id,
      { type: 'CheckLink', format: 'json' }
    )
    return SFetch.jsonWithAlert(url, { method: 'POST' })
  },

  createCheckIn(checkId, currentCompanyId = Silverfin.currentCompanyId) {
    const url = Silverfin.Routes.check_link_checkins_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      checkId,
      { format: 'json' }
    )
    return SFetch.jsonWithAlert(url, { method: 'POST' })
  },

  deleteCheckIn(
    checkId,
    checkinId,
    currentCompanyId = Silverfin.currentCompanyId
  ) {
    const url = Silverfin.Routes.check_link_checkin_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      checkId,
      checkinId,
      { format: 'json' }
    )
    return SFetch.jsonWithAlert(url, { method: 'DELETE' })
  },
}
